import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  fareAlert: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    padding: '12px 16px',
    marginTop: 16,
    border: `1px solid ${Theme.palette.warning.main}`,
    borderRadius: 4,
    [Theme.breakpoints.up('md')]: {
      padding: '12px 24px',
    },
  },
  icon: {
    fill: Theme.palette.warning.main,
    width: 20,
    height: 20,
    flexShrink: 0,
    marginTop: 2,
  },
  content: {
    flex: 1,
  },
  title: {
    margin: 0,
    fontWeight: 700,
    color: Theme.palette.warning.main,
    fontSize: Theme.typography.size[1.5],
    lineHeight: '24px',
  },
  text: {
    margin: '4px 0 0',
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[1.5],
    lineHeight: '24px',
  },
}));

export default useStyles;
